import { Controller, useFormContext } from "react-hook-form"
import { DualColumnRow, SingleColumnRow } from "../../../../style"
import {
  TextField,
  parsePhoneNumberField,
} from "../../../../../../../../components/TextField"
import { Trans, t } from "@lingui/macro"

import { ContactData } from "../../types"
import { ContainerCard } from "../../../../../../../../components/ContainerCard"
import { DropdownField } from "../../../../../../../../components/DropdownField"
import { IdentityNumberController } from "../../../IdentityNumberController"
import { IdentityType } from "../../../../../../../../api/stores/checkout"
import { i18n } from "@lingui/core"
import { isValidEmail } from "../../../../../../utils/isValidEmail"
import { useCheckout } from "../../../../../../../../hooks"
import { useEffect } from "react"

type Option = { id: string; name: string; value: IdentityType }

const arrayOfAllOptions: ArrayOfAllUnion<Option> = array => array

export const CardContact = () => {
  const { contact } = useCheckout().data.meta
  const {
    control,
    errors,
    reset,
    watch,
    getValues,
  } = useFormContext<ContactData>()

  useEffect(() => {
    if (contact) {
      reset({
        contactFirstName: contact?.firstName || "",
        contactLastName: contact?.lastName || "",
        contactIdentityType:
          contact?.identityType || (i18n.locale === "es-MX" ? "OTHER" : "DU"),
        contactIdentityNumber: contact?.identityNumber || "",
        contactEmail: contact?.email || "",
        contactPhone: contact?.phone || "",
      })
    }
  }, [contact, reset])

  return (
    <ContainerCard title={<Trans>Completá tus datos</Trans>}>
      <SingleColumnRow>
        <DualColumnRow>
          <Controller
            control={control}
            name="contactFirstName"
            defaultValue=""
            rules={{
              required: t`Completá el campo con tu nombre.`,
            }}
            render={({ onChange, onBlur, value, name }) => (
              <TextField
                name={name}
                label={<Trans>Nombre</Trans>}
                errorMsg={errors.contactFirstName?.message}
                maxLength={100}
                hideLength={true}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="contactLastName"
            defaultValue=""
            rules={{
              required: t`Completá el campo con tu apellido.`,
            }}
            render={({ onChange, onBlur, value, name }) => (
              <TextField
                name={name}
                label={<Trans>Apellido</Trans>}
                errorMsg={errors.contactLastName?.message}
                maxLength={100}
                hideLength={true}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="contactIdentityType"
            defaultValue={i18n.locale === "es-MX" ? "OTHER" : "DU"}
            rules={{
              required: t`Elegí el tipo de documento.`,
            }}
            render={({ onChange, value }) => (
              <DropdownField
                name="contactIdentityType"
                label={<Trans>Tipo de documento</Trans>}
                errorMsg={errors.contactIdentityType?.message}
                options={arrayOfAllOptions(
                  i18n.locale === "es-MX"
                    ? [
                        {
                          id: "3",
                          name: t`Otro`,
                          value: "OTHER",
                        },
                        {
                          id: "1",
                          name: t`DNI`,
                          value: "DU",
                        },
                        {
                          id: "2",
                          name: t`CUIT`,
                          value: "CUIT",
                        },
                      ]
                    : [
                        {
                          id: "1",
                          name: t`DNI`,
                          value: "DU",
                        },
                        {
                          id: "2",
                          name: t`CUIT`,
                          value: "CUIT",
                        },
                        {
                          id: "3",
                          name: t`Otro`,
                          value: "OTHER",
                        },
                      ]
                )}
                value={value}
                onChange={onChange}
              />
            )}
          />
          <IdentityNumberController
            name="contactIdentityNumber"
            errorMsg={errors.contactIdentityNumber?.message}
            control={control}
            selectedIdentityType={watch("contactIdentityType") as IdentityType}
            defaultValue={getValues("contactIdentityNumber")}
          />
        </DualColumnRow>
        <Controller
          control={control}
          name="contactEmail"
          defaultValue=""
          rules={{
            required: t`Completá el campo con tu email.`,
            validate: {
              checkCorrectFormat: value => {
                if (!value) return true
                else
                  return (
                    isValidEmail(value) || t`Usá el formato hola@ejemplo.com`
                  )
              },
            },
          }}
          render={({ onChange, onBlur, value, name }) => (
            <TextField
              name={name}
              label={<Trans>Email</Trans>}
              errorMsg={errors.contactEmail?.message}
              type="text"
              maxLength={254}
              hideLength
              value={value}
              onBlur={onBlur}
              onChange={e =>
                onChange(e.target.value.replace(/\s+/g, "").toLowerCase())
              }
            />
          )}
        />
        <Controller
          control={control}
          name="contactPhone"
          defaultValue=""
          rules={{
            required: t`Completá el campo con tu teléfono.`,
          }}
          render={({ onChange, value }) => (
            <TextField
              name="contactPhone"
              label={<Trans>Teléfono</Trans>}
              errorMsg={errors.contactPhone?.message}
              type="tel"
              maxLength={20}
              hideLength={true}
              onChange={e => onChange(parsePhoneNumberField(e.target.value))}
              value={value}
            />
          )}
        />
      </SingleColumnRow>
    </ContainerCard>
  )
}
